import { ErrorMessage, Field } from "formik";
import { LoginFormData, LoginStepProps } from "./StepModel";
import clsx from "clsx";
import { Dispatch, SetStateAction } from "react";
import { AnyAction } from "redux";
import { incrementCurrentStep } from "../LoginPageSlice";
import { ThunkDispatch } from "redux-thunk";

export const EmailAddressStep: React.FC<LoginStepProps> = ({
  currentStep,
  formikProps,
  onInputChange,
}: LoginStepProps) => (
  <>
    {/* begin::Form group */}
    <div className="fv-row mb-10">
      <label className="form-label fs-6 fw-bolder" htmlFor="emailAddress">
        Email
      </label>
      <Field
        className={clsx(
          "form-control bg-transparent",
          { "is-invalid": formikProps.touched.emailAddress && formikProps.errors.emailAddress },
          {
            "is-valid": formikProps.touched.emailAddress && !formikProps.errors.emailAddress,
          }
        )}
        type="email"
        name="emailAddress"
        id="emailAddress"
        autoComplete="username"
        data-test-id="login-form__email-input"
        onChange={(event: { target: { value: SetStateAction<string> } }) => {
          formikProps.setFieldValue("emailAddress", event.target.value);
          onInputChange();
        }}
      />
      <div className="fv-plugins-message-container">
        <div className="fv-help-block">
          <ErrorMessage name="emailAddress" key={currentStep.toString()} />
        </div>
      </div>
    </div>
    {/* end::Form group */}
  </>
);

export const EmailAddressSubmit = (
  values: LoginFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(incrementCurrentStep());
};
